import request from './request';

const uri = 'user/';

const user = {
  get: (id = '', options) => request(uri + id, options),
};

export default user;
